import { CoreTextView } from '@core/widgets';
import React from 'react';
import { IMargin } from '../../../interface/interface';
import { TextStyle } from '../../../types/styles';
import { getInlineStyles } from '../../../utils/styles';
import styles from '../Calculator.module.css';

interface TPricingTabProps extends IMargin {
    text?: string;
    fee?: string;
}

const PricingTab = (props: TPricingTabProps) => {
    const margin = {
        top: props.marginTop,
        bottom: props.marginBottom,
        left: props.marginLeft,
        right: props.marginRight,
    };
    return (
        <div className={styles.pricingTabBlock} style={getInlineStyles({ margin })}>
            <CoreTextView as="span" text={props.text} styleProps={{ ...TextStyle.subheader, main: 'var(--color-black)' }} />
            <CoreTextView as="span" text={props.fee} styleProps={{ ...TextStyle.subheader, main: 'var(--color-purple_100)' }} />
        </div>
    );
};
export default PricingTab;
